document.addEventListener("DOMContentLoaded", function () {
  function mobimgslide2() {
    if ($(window).width() <= 1200) {
      if ($(".cd-item-wrapper").length > 0) {
        if ($(".cd-item-wrapper").hasClass("slick-initialized")) {
          $(".cd-item-wrapper.slick-initialized").slick("unslick");
        }
        $(".cd-item-wrapper").slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
        });
      }
    }
  }
  function blogslick() {
    if ($(window).width() < 590) {
      if ($(".list-blog").length > 0) {
        if ($(".list-blog").hasClass("slick-initialized")) {
          $(".list-blog.slick-initialized").slick("unslick");
        }
        $(".list-blog").slick({
          infinite: false,
          draggable: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          nextArrow:
            '<button type="button" class="slick-next" role="button" aria-label="Next"><i class="fa fa-angle-right"></i></button>',
          prevArrow:
            '<button type="button" class="slick-prev" role="button" aria-label="Previous"><i class="fa fa-angle-left"></i></button>',
        });
      }
    }
  }
  $(document).ready(function () {
    var singleArr = [];
    var multiArr = [];
    var parent = $("#finder-page");
    var stepContainer = $(`.stepscontainer`);
    var finder_option = $(".finder-option");
    var filterItem = $(".filter-item");
    var match_message = $("#match-message");
    var result_box = $("#finder-result");
    var price_option = $(".finder-price-option");

    //level first to start
    function init() {
      var multi, level, name, tag, islast, bgImage;
      finder_option.on("click", function () {
        multi = $(this).parents(`.finder-level`).hasClass(`multi-choice`);
        level = parseInt($(this).attr("data-level"));
        name = $(this).attr("filter-name");
        id = $(this).attr("data-id");
        tag = $(this).attr(`data-tag`);
        islast = $(this).attr("data-last");
        bgImage = "url(" + $(this).attr("filter-bg") + ")";
        index = $(this).index();
        has_choose = parseInt(
          $(this).parents(".multi-choice").attr("data-choose")
        );
        tem_choose = has_choose;
        if (!multi) {
          //single
          if ($(this).attr(`data-tag`) != `no-preference`) {
            $(this)
              .addClass("active")
              .siblings(".finder-option")
              .removeClass("active");
            $(`.stepscontainer .step-item[data-level="${level}"]`).remove();
            stepContainer.append(
              `<span data-step="${level}" class="step-item havechoose" data-tag="${tag}" data-level="${level}" data-id="${id}" style="background-image:${bgImage}"><b>${name}</b></span>`
            );
            if (islast == "false") {
              setTimeout(function () {
                next(level);
              }, 100);
            }
          } else {
            $(this)
              .addClass("active")
              .siblings(".finder-option")
              .removeClass("active");
            setTimeout(function () {
              next(level);
            }, 100);
          }
        } else {
          //multi
          if ($(this).attr(`data-tag`) == `no-preference`) {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              if ($(`.step-item[data-tag="${tag}"]`).length) {
                $(`.stepscontainer .step-item[data-tag="${tag}"]`).remove();
              }
            } else {
              $(this).addClass("active");
              if ($(`.step-item[data-tag="${tag}"]`).length) {
                $(`.stepscontainer .step-item[data-tag="${tag}"]`).remove();
              }
              $(this).siblings(".finder-option").removeClass("active");
              setTimeout(function () {
                next(level);
              }, 100);
            }
          } else {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              tem_choose--;
              $(this).parents(".multi-choice").attr("data-choose", tem_choose);
              $(`.stepscontainer .step-item[data-tag="${tag}"]`).remove();
            } else {
              $(this).addClass("active");
              tem_choose++;
              $(this).parents(".multi-choice").attr("data-choose", tem_choose);
              $(this)
                .siblings(`.finder-option[data-tag='no-preference']`)
                .removeClass("active");
              if (!$(`.step-item[data-tag="${tag}"]`).length) {
                stepContainer.append(
                  `<span data-step="${level}" class="step-item havechoose" data-tag="${tag}" data-level="${level}" data-id="${id}" style="background-image:${bgImage}"><b>${name}</b></span>`
                );
              }
            }
            if (tem_choose != 0) {
              $(this)
                .parents(".multi-choice")
                .find(".submit-btn")
                .removeClass(`disabled`);
            } else {
              $(this)
                .parents(".multi-choice")
                .find(".submit-btn")
                .addClass(`disabled`);
            }
          }
        }
      });
      finder_option.keydown(function (e) {
        if (e.key == "Enter" || e.key == "") {
          $(this).click();
        }
      });

      price_choose();
    }

    function price_choose() {
      ischoose2 = false;
      price_option.on("click", function () {
        let index = $(this).index();
        $(this).parents(".price-progressbar").attr("data-currentindex", index);
        $(`.nosure-btn`).removeClass("active");
        switch (index) {
          case 0:
            if (!$(this).hasClass("active")) {
              $(this).addClass("active");
              if ($(`.step-item[data-level="5"][data-index="0]`).length <= 0) {
                stepContainer.append(
                  `<span data-step="5" data-index="0" class="step-item havechoose" data-tag="0-100" data-level="5" ><b>$0-$100 </b></span>`
                );
              }
              if ($(`.step-item[data-level="5"][data-index="1"]`).length > 0) {
                $(
                  `.stepscontainer .step-item[data-level="5"][data-index="1"]`
                ).remove();
                $(
                  `.price-progressbar .finder-price-option[data-index="1"]`
                ).removeClass("active");
              }
              if ($(`.step-item[data-level="5"][data-index="2"]`).length > 0) {
                $(
                  `.stepscontainer .step-item[data-level="5"][data-index="2"]`
                ).remove();
                $(
                  `.price-progressbar .finder-price-option[data-index="2"]`
                ).removeClass("active");
              }
            } else {
              if ($(`.step-item[data-level="5"][data-index="1"]`).length > 0) {
                $(
                  `.stepscontainer .step-item[data-level="5"][data-index="1"]`
                ).remove();
                $(
                  `.price-progressbar .finder-price-option[data-index="1"]`
                ).removeClass("active");
              }
              if ($(`.step-item[data-level="5"][data-index="2"]`).length > 0) {
                $(
                  `.stepscontainer .step-item[data-level="5"][data-index="2"]`
                ).remove();
                $(
                  `.price-progressbar .finder-price-option[data-index="2"]`
                ).removeClass("active");
              }
            }
            break;
          case 1:
            if (!$(this).hasClass("active")) {
              $(this).addClass("active");
              if ($(`.step-item[data-level="5"][data-index="0"]`).length <= 0) {
                stepContainer.append(
                  `<span data-step="5" data-index="0" class="step-item havechoose" data-tag="0-100" data-level="5" ><b>$0-$100 </b></span>`
                );
                $(
                  `.price-progressbar .finder-price-option[data-index="0"]`
                ).addClass("active");
              }
              if ($(`.step-item[data-level="5"][data-index="1"]`).length <= 0) {
                stepContainer.append(
                  `<span data-step="5" data-index="1" class="step-item havechoose" data-tag="100-150" data-level="5" ><b>$100-150</b></span>`
                );
                $(
                  `.price-progressbar .finder-price-option[data-index="1"]`
                ).addClass("active");
              }
              if ($(`.step-item[data-level="5"][data-index="2"]`).length > 0) {
                $(
                  `.stepscontainer .step-item[data-level="5"][data-index="2"]`
                ).remove();
                $(
                  `.price-progressbar .finder-price-option[data-index="2"]`
                ).removeClass("active");
              }
            } else {
              if ($(`.step-item[data-level="5"][data-index="2"]`).length > 0) {
                $(
                  `.stepscontainer .step-item[data-level="5"][data-index="2"]`
                ).remove();
                $(
                  `.price-progressbar .finder-price-option[data-index="2"]`
                ).removeClass("active");
              }
            }
            break;
          case 2:
            if (!$(this).hasClass("active")) {
              $(this).addClass("active");
              if ($(`.step-item[data-level="5"][data-index="0"]`).length <= 0) {
                stepContainer.append(
                  `<span data-step="5" data-index="0" class="step-item havechoose" data-tag="0-100" data-level="5" ><b>$0-$100 </b></span>`
                );
                $(
                  `.price-progressbar .finder-price-option[data-index="0"]`
                ).addClass("active");
              }
              if ($(`.step-item[data-level="5"][data-index="1"]`).length <= 0) {
                stepContainer.append(
                  `<span data-step="5" data-index="1" class="step-item havechoose" data-tag="100-150" data-level="5" ><b>$100-150</b></span>`
                );
                $(
                  `.price-progressbar .finder-price-option[data-index="1"]`
                ).addClass("active");
              }
              if ($(`.step-item[data-level="5"][data-index="2"]`).length <= 0) {
                stepContainer.append(
                  `<span data-step="5" data-index="2" class="step-item havechoose" data-tag="150-200" data-level="5" ><b>$150-200</b></span>`
                );
                $(
                  `.price-progressbar .finder-price-option[data-index="2"]`
                ).addClass("active");
              }
            }

            break;

          default:
        }
        $(this)
          .parents(".multi-choice")
          .find(".submit-btn")
          .removeClass(`disabled`);
      });
      price_option.keydown(function (e) {
        if (e.key == "Enter" || e.key == "") {
          $(this).click();
        }
      });
      $(`.nosure-btn`).click(function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          ischoose2 = false;
          $(this)
            .parents(".multi-choice")
            .find(".submit-btn")
            .addClass(`disabled`);
        } else {
          $(this).addClass("active");
          ischoose2 = true;
          if ($(`.step-item[data-level="5"]`).length > 0) {
            $(`.stepscontainer .step-item[data-level="5"]`).remove();
            $(`.price-progressbar .finder-price-option`).removeClass("active");
            $(".price-progressbar").attr("data-currentindex", "");
          }
          if (ischoose2) {
            $(this)
              .parents(".multi-choice")
              .find(".submit-btn")
              .removeClass(`disabled`);
          }
        }
      });
      $(`.nosure-btn`).keydown(function (e) {
        if (e.key == "Enter" || e.key == "") {
          $(this).click();
        }
      });
    }

    //level next function
    function next(level) {
      $("html,body").animate({ scrollTop: "0px" }, 50);
      var next_level = parseInt(level) + 1;
      $(`.finder-level[data-level='${level}']`).fadeOut(100);
      $(`.finder-level[data-level='${next_level}']`).fadeIn(200);
      parent.attr("data-current-step", next_level);
    }

    function prev(level) {
      $("html,body").animate({ scrollTop: "0px" }, 50);
      var prev_level = parseInt(level) - 1;
      $(`.finder-level[data-level='${level}']`).fadeOut(100);
      $(`.finder-level[data-level='${prev_level}']`).fadeIn(200);
      if (level == 1) {
        $(".pre-step").addClass("hide");
      }
      parent.attr("data-current-step", prev_level);
      match_message.fadeOut(800);
      result_box.fadeOut(800);
      $("#finder-result .filter-item").removeClass("hide");
      $(`#finder-form`).addClass(`hide`);
      $("#related-guides").addClass("hide");
      if ($(`.step-item[data-level="${prev_level}"]`).length > 0) {
        $(`.stepscontainer .step-item[data-level="${prev_level}"]`).remove();
      }
      $(`.finder-level[data-level="${level}"] .finder-option`).removeClass(
        "active"
      );
      $(
        `.finder-level[data-level="${level}"] .finder-price-option`
      ).removeClass("active");
      $(`.finder-level[data-level="${level}"] .nosure-btn`).removeClass(
        "active"
      );
      $(`.finder-level[data-level="${level}"] .submit-btn`).addClass(
        "disabled"
      );
      $(".price-progressbar").attr("data-currentindex", "");
    }

    // Reset function
    function reset() {
      singleArr = [];
      multiArr = [];
      $(`.stepscontainer .step-item`).remove();
      finder_option.removeClass("active");
      filterItem.removeClass(`hide`);
      match_message.fadeOut(800);
      result_box.fadeOut(800);
      $("#finder-result .filter-item").addClass("hide");
      $(".recommend-title").addClass("hide");
      $("#related-guides").addClass("hide");
      $(".finder-level").fadeOut(800);
      $(".finder-level.finder-level0").fadeIn(1000);
      parent.attr("data-current-step", 0);
      $("html,body").animate({ scrollTop: "0px" }, 50);
      $(".pre-step").addClass(`hide`);
      $(`#finder-form`).addClass(`hide`);
      $(".stepscontainer").html("");
      $(`.finder-level .finder-option`).removeClass("active");
      $(`.finder-level[data-level="5"] .finder-price-option`).removeClass(
        "active"
      );
      $(`.finder-level[data-level="5"] .nosure-btn`).removeClass("active");
      $(`.finder-level.multi-choice .submit-btn`).addClass("disabled");
    }
    $(".reset-btn").click(function () {
      reset();
    });

    $(".reset-btn").keydown(function (e) {
      if (e.key == "Enter" || e.key == "") {
        $(this).click();
      }
    });

    //level back function  |  no used
    function back(level, id, tag) {
      $("html,body").animate({ scrollTop: "0px" }, 50);
      var prev_level = parseInt(level);
      if (level == 1) {
        reset();
      } else {
        parent.attr("data-current-step", level);
        match_message.fadeOut(800);
        result_box.fadeOut(800);
        $(".finder-level").fadeOut(800);
        $(`.finder-level[data-level='${level}'][data-id='${id}']`).fadeIn(1000);
        $(`.finder-level[data-level='${level}'][data-id='${id}']`)
          .find(`.finder-option[data-tag="${tag}"]`)
          .removeClass("active");
        $(`.finder-level[data-level='${level}'][data-id='${id}']`)
          .find(`.finder-option[data-tag="${tag}"]`)
          .siblings()
          .removeClass(`disabled`);
        // $(`.stepscontainer .step-item[data-level="${level}"]`).remove();
      }
    }

    // Click step item back |  no used
    $(document).on(`click`, `.step-item`, function () {
      var click_level = $(this).attr("data-level");
      var click_id = $(this).attr("data-id");
      var click_tag = $(this).attr("data-tag");
      if (click_level != 1) {
        $(this).remove();
      }
      setTimeout(function () {
        back(click_level, click_id, click_tag);
      }, 800);
    });

    // Get tag array normal
    function getTagArray() {
      singleArr = [];
      multiArr = [];
      if ($(`.step-item[data-level="1"]`).length > 0) {
        singleArr.push($(`.step-item[data-level="1"]`).attr(`data-tag`));
      }
      if ($(`.step-item[data-level="2"]`).length > 0) {
        singleArr.push($(`.step-item[data-level="2"]`).attr(`data-tag`));
      }
      if ($(`.step-item[data-level="3"]`).length > 0) {
        $(`.step-item[data-level="3"]`).each(function () {
          multiArr.push($(this).attr(`data-tag`));
        });
      }
      if ($(`.step-item[data-level="4"]`).length > 0) {
        $(`.step-item[data-level="4"]`).each(function () {
          multiArr.push($(this).attr(`data-tag`));
        });
      }
      if ($(`.step-item[data-level="5"]`).length > 0) {
        $(`.step-item[data-level="5"]`).each(function () {
          multiArr.push($(this).attr(`data-tag`));
        });
      }
    }

    // Get get_match
    function getMatch() {
      var get_match = ``;
      var match_level1 = $(`.step-item[data-level="1"]`).html() || "";
      var match_level2 = $(`.step-item[data-level="2"]`).html() || "";
      var match_level3 = $(`.step-item[data-level="3"]`).html() || "";
      var match_level3 = $(`.step-item[data-level="4"]`).html() || "";
      var match_level3 = $(`.step-item[data-level="5"]`).html() || "";
      if (match_level1 != "") {
        get_match = `${match_level1}`;
      }
      if (match_level2 != "") {
        get_match = `${match_level1}${match_level2}`;
      }
      $(`.step-item[data-level="3"]`).each(function () {
        var temp = $(this).html();
        get_match += temp;
      });
      $(`.step-item[data-level="4"]`).each(function () {
        var temp = $(this).html();
        get_match += temp;
      });
      $(`.step-item[data-level="5"]`).each(function () {
        var temp = $(this).html();
        get_match += temp;
      });
      return get_match;
    }

    // Filter function
    function filterProduct() {
      getTagArray();
      var result_count = 0;

      $(".filter-item").each(function (i) {
        match = false;
        matchtag0 = false;
        matchtag1 = false;
        matchtag2 = false;
        var product = $(this);
        var filterPtag = product.data("tags").split(",");
        if (singleArr.length > 0) {
          $.each(singleArr, function (index, value) {
            if (filterPtag.indexOf(value) < 0) {
              matchtag0 = false;
              return false;
            } else {
              matchtag0 = true;
            }
          });
          matchtag1 = matchtag0;
        } else {
          matchtag1 = true;
        }
        if (multiArr.length > 0) {
          $.each(filterPtag, function (index, value) {
            if (multiArr.indexOf(value) >= 0) {
              matchtag2 = true;
              return false;
            }
          });
        } else {
          matchtag2 = true;
        }
        match = matchtag1 && matchtag2;
        if (match) {
          product.removeClass("hide");
          result_count++;
        } else {
          product.addClass("hide");
        }
      });
      var get_match_str = getMatch();
      if (result_count == 0) {
        match_message
          .fadeIn()
          .html(
            `<div class='h1'>0 MATCH</div><div class='match-val'>${get_match_str}</div>`
          );
        showRecommend();
        showGuide();
      } else {
        match_message
          .fadeIn()
          .html(
            `<header class='page-header'><h2 class='title-36 text-center'>Our Picks for You</h2></header><div class='h1' style="font-weight:500;">100% MATCH</div><div class='match-val'>${get_match_str}</div>`
          );
        showResult();
      }
      mobimgslide2();
      setTimeout(function () {
        blogslick();
      }, 3000);
    }

    // Show Result
    function showResult() {
      $("html,body").animate({ scrollTop: "0px" }, 50);
      $(".finder-level").fadeOut(800);
      match_message.fadeIn(800);
      result_box.fadeIn(800);
      result_box.find(".product-collection").css("display", "flex");
      $(".recommend-title").addClass("hide");
      setTimeout(function () {
        mobimgslide2();
      }, 1000);
      $(`#finder-form`).removeClass(`hide`);
    }
    function showGuide() {
      $("html,body").animate({ scrollTop: "0px" }, 50);
      match_message.fadeIn(800);
      $("#related-guides").removeClass("hide");
      if($("#related-guides .list-blog li").length == 0) {$("#related-guides .page-header").addClass("hide");}
      setTimeout(function () {
        blogslick();
      }, 1500);
    }
    // Show Recommend
    function showRecommend() {
      $("html,body").animate({ scrollTop: "0px" }, 50);
      result_box.fadeIn(800);
      result_box.find(".product-collection").css("display", "flex");
      $(".recommend-title").removeClass("hide");
      $("#finder-result .filter-item").removeClass("hide");
      setTimeout(function () {
        mobimgslide2();
      }, 1000);
    }

    $(".submit-btn").on("click", function () {
      let level = parseInt($(this).attr("data-level"));
      let islast = $(this).attr("data-last");
      setTimeout(function () {
        next(level);
      }, 100);
      if (islast == "true") {
        mobimgslide2();
        filterProduct();
      }
    });
    $(".submit-btn").keydown(function (e) {
      if (e.key == "Enter" || e.key == "") {
        $(this).click();
      }
    });

    $(`.start-btn`).click(function () {
      let level = parseInt($(this).attr("data-level"));
      let id = $(this).attr("data-id");
      setTimeout(function () {
        next(level);
        $(".pre-step").removeClass("hide");
      }, 100);
    });
    $(`.start-btn`).keydown(function (e) {
      if (e.key == "Enter" || e.key == "") {
        $(this).click();
      }
    });

    $(`.pre-step`).click(function () {
      let level = parseInt($("#finder-page").attr("data-current-step"));
      setTimeout(function () {
        prev(level);
      }, 100);
    });
    $(`.pre-step`).keydown(function (e) {
      if (e.key == "Enter" || e.key == "") {
        $(this).click();
      }
    });

    // No preference
    $(`.finder-option[data-tag="no-preference"]`).click(function () {
      if (!$(this).hasClass(`active`)) {
        var level = $(this).attr(`data-level`);
        var tag = $(this).attr(`data-tag`);
        var id = $(this).attr(`data-id`);
        $(
          `.stepscontainer .step-item[data-level="${level}"][data-level!="${tag}"]`
        ).remove();
        $(`.finder-level[data-level='${level}'][data-id='${id}']`)
          .find(`.finder-option[data-tag!="${tag}"]`)
          .removeClass("active");
      }
    });

    $(`.finder-option[data-tag="no-preference"]`).keydown(function (e) {
      if (e.key == "Enter" || e.key == "") {
        $(this).click();
      }
    });

    init();
    blogslick();
  });
});
